module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cRPGL"))).then(() => parcelRequire('fThBo'));